import { useEffect, useState } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative overflow-hidden" id="anasayfa" style={{ background: '#080808', minHeight: '100vh' }}>

      {/* Arka plan — Türk sarı taksi görseli */}
      <div className="absolute inset-0 z-0">
        <img
          src="/8.jpg"
          alt="Başharık Taksi Malatya - Profesyonel Taksi Hizmeti ve Havalimanı Transferi"
          className="w-full h-full object-cover object-center"
          style={{ filter: 'brightness(0.28) saturate(1.2)', transform: 'translateY(-2%)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/98 via-black/75 to-black/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-transparent to-black/50" />
      </div>

      {/* Animasyonlu arka plan grid deseni */}
      <div
        className="absolute inset-0 z-0 opacity-5"
        style={{
          backgroundImage: 'linear-gradient(#FACC15 1px, transparent 1px), linear-gradient(90deg, #FACC15 1px, transparent 1px)',
          backgroundSize: '60px 60px',
          animation: 'gridMove 8s linear infinite',
        }}
      />

      {/* Yol şeridi animasyonu */}
      <div className="absolute bottom-20 left-0 right-0 z-10 overflow-hidden" style={{ height: '4px' }}>
        <div
          className="h-full"
          style={{
            background: 'repeating-linear-gradient(90deg, #FACC15 0px, #FACC15 60px, transparent 60px, transparent 120px)',
            animation: 'roadStripe 1.2s linear infinite',
            width: '200%',
          }}
        />
      </div>

      {/* Sol sarı dikey şerit */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-yellow-400 z-20" />

      {/* Sol dikey yazı */}
      <div className="absolute left-6 top-1/2 -translate-y-1/2 z-20 hidden lg:flex flex-col items-center gap-3">
        <div className="w-px bg-yellow-400/40" style={{ height: visible ? '64px' : '0px', transition: 'height 1s ease 0.8s' }} />
        <span
          className="text-yellow-400/60 font-black text-[10px] uppercase tracking-[0.5em]"
          style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', fontFamily: "'Oswald', sans-serif", opacity: visible ? 1 : 0, transition: 'opacity 1s ease 1s' }}
        >
          TAKSİ HİZMETİ
        </span>
        <div className="w-px bg-yellow-400/40" style={{ height: visible ? '64px' : '0px', transition: 'height 1s ease 0.8s' }} />
      </div>

      {/* Sağ dikey yazı */}
      <div className="absolute right-6 top-1/2 -translate-y-1/2 z-20 hidden lg:flex flex-col items-center gap-3">
        <div className="w-px bg-yellow-400/40" style={{ height: visible ? '64px' : '0px', transition: 'height 1s ease 0.8s' }} />
        <span
          className="text-yellow-400/60 font-black text-[10px] uppercase tracking-[0.5em]"
          style={{ writingMode: 'vertical-rl', fontFamily: "'Oswald', sans-serif", opacity: visible ? 1 : 0, transition: 'opacity 1s ease 1s' }}
        >
          7/24 AÇIK
        </span>
        <div className="w-px bg-yellow-400/40" style={{ height: visible ? '64px' : '0px', transition: 'height 1s ease 0.8s' }} />
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-black/95 backdrop-blur-md shadow-2xl border-b border-yellow-400/20' : 'bg-transparent'}`}>
        <div className="mx-auto px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3 group cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center bg-yellow-400 rounded-lg shadow-lg shadow-yellow-400/30 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-taxi-line text-xl text-black" />
              </div>
              <div>
                <span className="text-lg font-black text-white tracking-tight uppercase leading-none block" style={{ fontFamily: "'Oswald', sans-serif" }}>Başharık</span>
                <span className="text-xs font-bold text-yellow-400 tracking-widest uppercase leading-none">TAKSİ</span>
              </div>
            </div>

            <div className="hidden md:flex items-center space-x-7 text-sm font-semibold text-white/70">
              {[['Anasayfa','#anasayfa'],['Hizmetler','#hizmetler'],['Hakkımızda','#hakkimizda'],['Yorumlar','#yorumlar'],['İletişim','#iletisim']].map(([label, href], i) => (
                <a key={i} href={href} className="hover:text-yellow-400 transition-colors duration-300 relative group whitespace-nowrap">
                  {label}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-yellow-400 group-hover:w-full transition-all duration-300" />
                </a>
              ))}
            </div>

            <div className="flex items-center space-x-3">
              <a href="tel:05308920944"
                className="bg-yellow-400 hover:bg-yellow-300 text-black px-5 py-2.5 rounded-lg font-black flex items-center space-x-2 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm shadow-lg shadow-yellow-400/30 hover:scale-105">
                <i className="ri-phone-fill text-base" />
                <span>0530 892 09 44</span>
              </a>
              <a href="https://wa.me/905302064644" target="_blank" rel="nofollow noreferrer"
                className="bg-green-500 hover:bg-green-400 text-white px-5 py-2.5 rounded-lg font-black flex items-center space-x-2 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm shadow-lg shadow-green-500/30 hover:scale-105">
                <i className="ri-whatsapp-line text-base" />
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Ana İçerik */}
      <article className="relative z-10 flex flex-col justify-center" style={{ minHeight: '100vh', paddingTop: '80px' }}>
        <div className="px-16 lg:px-28 max-w-7xl">

          {/* Üst etiket */}
          <div
            className="flex items-center gap-3 mb-8"
            style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(-30px)', transition: 'all 0.8s cubic-bezier(0.16,1,0.3,1) 0.1s' }}
          >
            <div className="h-px w-10 bg-yellow-400" />
            <span className="text-yellow-400 font-bold text-xs tracking-[0.4em] uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Güvenilir &bull; Hızlı &bull; 7/24
            </span>
          </div>

          {/* Devasa başlık */}
          <div style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateX(0)' : 'translateX(-60px)', transition: 'all 1s cubic-bezier(0.16,1,0.3,1) 0.2s' }}>
            <h1
              className="font-black uppercase leading-none block"
              style={{ fontFamily: "'Oswald', sans-serif", fontSize: 'clamp(72px, 11vw, 160px)', letterSpacing: '-0.02em', lineHeight: 0.88 }}
            >
              <span className="text-white block" style={{ textShadow: '0 0 80px rgba(250,204,21,0.15)' }}>BAŞHARIK</span>
              <span className="block relative" style={{ color: '#FACC15', textShadow: '0 0 120px rgba(250,204,21,0.5), 0 0 40px rgba(250,204,21,0.3)', animation: visible ? 'glowPulse 3s ease-in-out infinite 1.5s' : 'none' }}>TAKSİ</span>
            </h1>
          </div>

          {/* Alt yazı */}
          <div className="mt-6" style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)', transition: 'all 0.8s cubic-bezier(0.16,1,0.3,1) 0.5s' }}>
            <div className="flex items-center gap-4 mb-5">
              <div className="h-0.5 bg-yellow-400" style={{ width: visible ? '64px' : '0px', transition: 'width 1s ease 0.8s' }} />
              <p className="text-white/50 text-sm font-semibold tracking-[0.25em] uppercase">Şehir İçi &amp; Şehirler Arası Ulaşım</p>
            </div>
            <div className="flex items-center gap-3 mb-2" style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.8s ease 0.7s' }}>
              <div className="w-6 h-6 flex items-center justify-center bg-yellow-400 rounded-sm flex-shrink-0">
                <i className="ri-bank-card-fill text-black text-xs" />
              </div>
              <span className="text-yellow-400/80 text-xs font-bold tracking-widest uppercase">Kredi Kartı Geçerlidir</span>
            </div>
          </div>

          {/* Telefon butonu */}
          <div style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.9)', transition: 'all 0.9s cubic-bezier(0.16,1,0.3,1) 0.6s' }}>
            <a
              href="tel:05308920944"
              className="inline-flex items-center gap-4 bg-yellow-400 hover:bg-yellow-300 text-black px-10 py-5 font-black text-xl tracking-wide uppercase transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105 relative overflow-hidden group"
              style={{ fontFamily: "'Oswald', sans-serif", clipPath: 'polygon(14px 0%, 100% 0%, calc(100% - 14px) 100%, 0% 100%)', boxShadow: '0 0 40px rgba(250,204,21,0.4)' }}
            >
              <div className="absolute inset-0 bg-white/30 -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
              <i className="ri-phone-fill text-2xl relative z-10" style={{ animation: 'phoneBounce 1.5s ease-in-out infinite' }} />
              <span className="relative z-10">0530 892 09 44</span>
              <i className="ri-arrow-right-line text-2xl relative z-10 group-hover:translate-x-2 transition-transform duration-300" />
            </a>
          </div>

          {/* İstatistikler */}
          <div className="flex items-center gap-12 mt-14" style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(30px)', transition: 'all 0.8s cubic-bezier(0.16,1,0.3,1) 0.9s' }}>
            {[{ num: 'Şehir İçi', label: 'Ulaşım' }, { num: 'Şehirler', label: 'Arası Sefer' }, { num: '7/24', label: 'Kesintisiz Hizmet' }].map((s, i) => (
              <div key={i} className="flex items-center gap-4">
                {i > 0 && <div className="w-px h-10 bg-white/15" />}
                <div className="group cursor-default">
                  <div className="text-yellow-400 font-black text-2xl leading-none group-hover:scale-110 transition-transform duration-300" style={{ fontFamily: "'Oswald', sans-serif" }}>{s.num}</div>
                  <div className="text-white/40 text-xs font-semibold uppercase tracking-widest mt-1">{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Sağ taraf — dekoratif kutu */}
        <div
          className="absolute right-0 top-1/2 -translate-y-1/2 hidden xl:flex flex-col items-end gap-6 pr-20"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(-50%) translateX(0)' : 'translateY(-50%) translateX(60px)', transition: 'all 1.1s cubic-bezier(0.16,1,0.3,1) 0.7s' }}
        >
          {/* 7/24 rozet */}
          <div className="relative">
            <div className="w-36 h-36 rounded-full border-4 border-yellow-400 bg-black/60 backdrop-blur-sm flex flex-col items-center justify-center shadow-2xl" style={{ boxShadow: '0 0 60px rgba(250,204,21,0.3), inset 0 0 30px rgba(250,204,21,0.05)' }}>
              <span className="text-yellow-400 font-black text-4xl leading-none" style={{ fontFamily: "'Oswald', sans-serif" }}>7/24</span>
              <span className="text-white font-bold text-xs tracking-widest uppercase mt-1">HİZMET</span>
            </div>
            <div className="absolute inset-0 rounded-full border-2 border-dashed border-yellow-400/30 animate-spin" style={{ animationDuration: '10s' }} />
            <div className="absolute inset-[-8px] rounded-full border border-yellow-400/10 animate-spin" style={{ animationDuration: '20s', animationDirection: 'reverse' }} />
          </div>

          {/* Özellik kartları */}
          {[{ icon: 'ri-shield-check-fill', text: 'Güvenli Yolculuk' }, { icon: 'ri-map-pin-2-fill', text: 'Şehirler Arası' }, { icon: 'ri-bank-card-fill', text: 'Kredi Kartı Geçerli' }].map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 bg-black/50 backdrop-blur-sm border border-yellow-400/20 px-5 py-3 hover:border-yellow-400/70 hover:bg-yellow-400/10 transition-all duration-300 cursor-default group"
              style={{ clipPath: 'polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%)', opacity: visible ? 1 : 0, transform: visible ? 'translateX(0)' : 'translateX(40px)', transition: `all 0.8s cubic-bezier(0.16,1,0.3,1) ${0.9 + i * 0.15}s` }}
            >
              <div className="w-8 h-8 flex items-center justify-center bg-yellow-400 rounded-sm flex-shrink-0 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className={`${item.icon} text-black text-sm`} />
              </div>
              <span className="text-white font-bold text-sm whitespace-nowrap" style={{ fontFamily: "'Oswald', sans-serif" }}>{item.text}</span>
            </div>
          ))}
        </div>
      </article>

      {/* Alt Sarı Şerit */}
      <div className="absolute bottom-0 left-0 right-0 w-full bg-yellow-400 z-20">
        <div className="max-w-7xl mx-auto px-8 py-4">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <a href="tel:05308920944" className="flex items-center space-x-3 group cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-black rounded-full flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-phone-fill text-yellow-400 text-base" />
              </div>
              <span className="text-black font-black text-sm whitespace-nowrap" style={{ fontFamily: "'Oswald', sans-serif" }}>0530 892 09 44</span>
            </a>
            <div className="hidden md:block w-px h-6 bg-black/20" />
            <a href="tel:05302064644" className="flex items-center space-x-3 group cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-black rounded-full flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-phone-fill text-yellow-400 text-base" />
              </div>
              <span className="text-black font-black text-sm whitespace-nowrap" style={{ fontFamily: "'Oswald', sans-serif" }}>0530 206 46 44</span>
            </a>
            <div className="hidden md:block w-px h-6 bg-black/20" />
            <a href="https://instagram.com/44t0702" target="_blank" rel="nofollow noreferrer" className="flex items-center space-x-3 group cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-black rounded-full flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-instagram-fill text-yellow-400 text-base" />
              </div>
              <span className="text-black font-black text-sm whitespace-nowrap" style={{ fontFamily: "'Oswald', sans-serif" }}>@44t0702</span>
            </a>
            <div className="hidden md:block w-px h-6 bg-black/20" />
            <div className="flex items-center space-x-3">
              <div className="w-9 h-9 flex items-center justify-center bg-black rounded-full flex-shrink-0">
                <i className="ri-bank-card-fill text-yellow-400 text-base" />
              </div>
              <span className="text-black font-black text-sm whitespace-nowrap" style={{ fontFamily: "'Oswald', sans-serif" }}>Kredi Kartı Geçerlidir</span>
            </div>
          </div>
        </div>
      </div>

      {/* CSS Animasyonları */}
      <style>{`
        @keyframes gridMove {
          0% { background-position: 0 0; }
          100% { background-position: 60px 60px; }
        }
        @keyframes roadStripe {
          0% { transform: translateX(0); }
          100% { transform: translateX(-120px); }
        }
        @keyframes glowPulse {
          0%, 100% { text-shadow: 0 0 120px rgba(250,204,21,0.5), 0 0 40px rgba(250,204,21,0.3); }
          50% { text-shadow: 0 0 180px rgba(250,204,21,0.8), 0 0 80px rgba(250,204,21,0.5), 0 0 20px rgba(250,204,21,0.9); }
        }
        @keyframes phoneBounce {
          0%, 100% { transform: rotate(0deg); }
          20% { transform: rotate(-15deg); }
          40% { transform: rotate(15deg); }
          60% { transform: rotate(-10deg); }
          80% { transform: rotate(10deg); }
        }
      `}</style>
    </section>
  );
}
